<template>
  <Tooltip>
    <template #element>
      <span>
        Aufmerksamkeit
      </span>
      <InformationCircleIcon class="info-icon" />
    </template>
    <template #content>
      <span>
        Bewertung, wie gut die Methode dabei helfen kann die Aufmerksamkeit der Hörer*innen über den gesamten Verlauf einer Folge aufrechtzuerhalten
      </span>
    </template>
  </Tooltip>
</template>

<style scoped>
.info-icon
{
  @apply h-5 w-5 inline-block;
  @apply text-gray-400;
}
</style>
